import Signup from '../components/signupHandler'
import Mixpanel from '../modules/mixpanel'

class TeamSignup {
  constructor() {
    this.cacoo = require('../components/cacoo').cacoo
    this.signup = new Signup('signupForm')
    this.spaceName = $('input[name="spaceName"]', this.signup.form)
    this.planSelect = $('#planKey', this.signup.form)
    this.spaceKey = $('input[name="spaceKey"]', this.signup.form)
    this.mixpanel = new Mixpanel()
    this.organizationRadio = $(
      'input[name="organizationMethod"]',
      this.signup.form,
    )
    this.orgKeySelection = $('#orgKeySelection', this.signup.form)

    const defaultPlanType = this.cacoo.util.getUrlParameter('planType')
    this.planSelect.val(defaultPlanType ? defaultPlanType : 'cacoo.team.trial')

    const signupSource = this.cacoo.util.getUrlParameter('source')
    if (signupSource === "pro") {
      $('#isPro', this.signup.form).val(true)
    }


    this.attachEvent()

    if (this.organizationRadio.length > 0) {
      this.attachOrganizationSelectionEvent()
    } else {
      // Show organization name input
      $('.js_toggle-select', this.signup.form).show()
    }
    this.sendViewTrial()

  }

  attachEvent() {
    this.signup.submitButton.on('click', (e) => {
      e.preventDefault()
      this.companyValidation()

      if(!this.signup.finalValidate()) {
        return false;
      }
      if(this.spaceName.val().length === 0) {
        this.spaceName.val(this.signup.fullName.val())
      }

      this.submitForm()
      return true
    })
  }

  attachOrganizationSelectionEvent() {
    this.updateOrganizationSelectionContent(false)
    this.updateSpaceKey()

    this.organizationRadio.on('click', () => {
      this.updateOrganizationSelectionContent(true)
      this.updateSpaceKey()
    })

    this.orgKeySelection.on('change', () => {
      this.updateSpaceKey()
    })
  }

  updateOrganizationSelectionContent(animation) {
    for (const radio of this.organizationRadio) {
      const $radio = $(radio)
      const element = $('.js_toggle-select', $radio.parent())
      if (!$radio.is(':checked')) {
        animation ? element.slideUp() : element.hide()
      } else {
        animation ? element.slideDown() : element.show()
        $('input', element).focus()
      }
    }
  }

  updateSpaceKey() {
    for (const radio of this.organizationRadio) {
      const $radio = $(radio)
      if ($radio.is(':checked')) {
        if ($radio.attr('id') === 'createNewOrg') {
          this.spaceKey.attr('value', '')
        } else {
          this.spaceKey.attr('value', this.orgKeySelection.val())
        }
      }
    }
  }

  companyValidation() {
    if (this.spaceKey.val() !== '') {
      return true
    }

    // Hides an error when the error is displayed and input is less than 100 characters.
    if (this.spaceName.hasClass('is_error') && this.spaceName.val().length < 100) {
      this.signup.formMessageHandler.removeError('spaceName')
    }

    if (this.spaceName.val().length > 0) {
      if (this.spaceName.val().length >= 100) {
        this.signup.formMessageHandler.showError(
          'spaceName',
          Cacoo.SiteResources['modal_signup_space_name_length_error'],
        )
        return false
      }
      this.signup.formMessageHandler.showSuccess(['spaceName'])
    }

    return true
  }

  submitForm() {
    if (!this.companyValidation()) {
      return false
    }

    this.sendMixpanelEvent()
    this.signup.submitForm()
  }

  sendMixpanelEvent() {
    const planNames = {
      'cacoo.team3': 'Cacoo for Team 3 Users',
      'cacoo.team5': 'Cacoo for Team 5 Users',
      'cacoo.team10': 'Cacoo for Team 10 Users',
      'cacoo.team15': 'Cacoo for Team 15 Users',
      'cacoo.team20': 'Cacoo for Team 20 Users',
      'cacoo.team25': 'Cacoo for Team 25 Users',
      'cacoo.team30': 'Cacoo for Team 30 Users',
      'cacoo.team50': 'Cacoo for Team 50 Users',
      'cacoo.team75': 'Cacoo for Team 75 Users',
      'cacoo.team100': 'Cacoo for Team 100 Users',
      'cacoo.team200': 'Cacoo for Team 200 Users',
      'cacoo.team.trial': 'Cacoo for Team Trial',
    }

    let referringDomain = 'direct' // indicates organic access
    this.mixpanel.getParam('mp_medium', function(value) {
      if (document.referrer !== '' && value !== '') {
        referringDomain = decodeURIComponent(value)
      }
    })
    let trackingData = {
      'Signup Email': this.signup.mail.val(),
      'Signup Referring Domain': referringDomain,
    }

    const plan = $(this.signup.form)
      .find('option:selected')
      .val()
    if (typeof planNames[plan] !== 'undefined') {
      trackingData['Plan Type at Signup Start'] = planNames[plan]
    }

    this.mixpanel.trackSignup('Nulab Account', trackingData)
  }

  sendViewTrial() {
    this.mixpanel.track('Viewed Team Signup form', {})
    if (mixpanel.nulab) {
      mixpanel.nulab.track('[Cacoo] Viewed Team Signup form', {})
    }
  }
}

if ($('body').hasClass('page--team-signup') || $('body').hasClass('page--team-dashboard-signup')) {
  new TeamSignup()
}
